/**
 * A caixa do código do segundo fator, nas ações que exigem ele.
 *
 * Existe como peça própria porque ela aparece em **quatro** formulários: cortar um notebook,
 * devolver o acesso, inscrever um notebook novo e desligar o segundo fator de outra pessoa. O
 * rótulo e a frase de ajuda precisam ser os mesmos nos quatro: quem já viu num deles reconhece
 * nos outros, e a frase que lembra do código de emergência não pode existir só em três.
 *
 * Ela não valida nada. Quem decide se o código serve é o servidor, sempre.
 */
import type { JSX } from 'react'

export function CaixaDoCodigo({
  valor,
  aoMudar,
  desabilitada
}: {
  valor: string
  aoMudar: (novo: string) => void
  desabilitada?: boolean
}): JSX.Element {
  return (
    <label>
      Código do aplicativo
      <input
        className="campo codigo"
        type="text"
        value={valor}
        onChange={(e) => aoMudar(e.target.value)}
        /*
         * Teclado de números no celular, mas o tipo continua texto: um código de emergência
         * tem letras, e `type="number"` engoliria elas sem avisar ninguém.
         */
        inputMode="numeric"
        autoComplete="one-time-code"
        spellCheck={false}
        maxLength={20}
        disabled={desabilitada === true}
        required
      />
      <span className="ajuda-do-codigo">
        Os seis números que o aplicativo do seu celular está mostrando. Perdeu o celular? Um dos
        códigos de emergência que você guardou serve aqui, e gasta um dos dez.
      </span>
    </label>
  )
}
